document.addEventListener('click', function (e) {
  var btn = e.target.closest('.upsell-card__atc[data-upsell-atc]');
  if (!btn) return;

  var productId = btn.getAttribute('data-product-id');
  var variantId = btn.getAttribute('data-variant-id');

  var selects = document.querySelectorAll('[data-upsell-select="' + productId + '"]');
  if (selects.length) {
    var selectedOptions = [];
    selects.forEach(function (sel) {
      selectedOptions.push(sel.value);
    });

    try {
      var variants = JSON.parse(btn.getAttribute('data-product-variants'));
      var matched = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });

      if (matched) variantId = matched.id;
    } catch (err) {
      // fall back to the button's default variant id
    }
  }

  if (!variantId) return;

  btn.disabled = true;
  btn.classList.add('is-loading');
  var originalText = btn.textContent.trim();
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = 'Added!';

      document.dispatchEvent(new CustomEvent('theme:update:cart'));
      document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
    })
    .catch(function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = 'Error – retry';
      setTimeout(function () {
        btn.textContent = originalText;
      }, 2500);
    });
}, true);

document.addEventListener('change', function (e) {
  var sel = e.target.closest('[data-upsell-select]');
  if (!sel) return;

  var productId = sel.getAttribute('data-upsell-product-id');
  var btn = document.querySelector('[data-upsell-atc][data-product-id="' + productId + '"]');
  if (!btn) return;

  var selects = document.querySelectorAll('[data-upsell-select="' + productId + '"]');
  var selectedOptions = [];
  selects.forEach(function (s) {
    selectedOptions.push(s.value);
  });

  var matched;
  try {
    var variants = JSON.parse(btn.getAttribute('data-product-variants'));
    matched = variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });
  } catch (err) {
    return;
  }

  if (!matched) return;

  var priceEl = document.querySelector('[data-upsell-price="' + productId + '"]');
  if (priceEl) {
    priceEl.textContent = (matched.price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: window.Shopify ? window.Shopify.currency.active : 'USD',
      minimumFractionDigits: 2,
    });
  }

  btn.setAttribute('data-variant-id', matched.id);
});
